import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconStyleguide({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M1.496 0h2.992c.827 0 1.497.672 1.497 1.5v1.032l1.634-1.375a1.494 1.494 0 0 1 2.108.185L11.65 3.64c.531.635.448 1.58-.184 2.113l-6.262 5.268A2.981 2.981 0 0 1 2.992 12 2.996 2.996 0 0 1 0 9V1.5C0 .672.67 0 1.496 0zm4.488 9.06 4.84-4.073a.5.5 0 0 0 .062-.704L8.962 1.985a.498.498 0 0 0-.702-.062L5.985 3.837V9l-.001.06zM1.496 1a.5.5 0 0 0-.499.5V9c0 1.105.894 2 1.995 2a1.997 1.997 0 0 0 1.995-2V1.5a.5.5 0 0 0-.499-.5H1.496zM3.99 9a.999.999 0 1 1-1.995 0c0-.552.446-1 .997-1 .551 0 .998.448.998 1z"/>
        </svg>

    );
}

export default IconStyleguide;

